import { Injectable } from "@angular/core";
import type { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { NodeSharedFacade } from '@medsurf/flat-facades';

@Injectable({
  providedIn: "root"
})
export class RedirectSharedResolver implements Resolve<void> {
  constructor(protected nodeSharedFacade: NodeSharedFacade) {
  }

  resolve(route: ActivatedRouteSnapshot) {
    const idSlug = route.paramMap.get('idSlug');
    if (idSlug) {
      this.nodeSharedFacade.requestRouteById(idSlug);
    }
  }
}